'use client'

import React from 'react'
import { Breadcrumbs } from '../../_components/Breadcrumps'
import AnimatedSection from '@/components/AnimatedSection'
import CtaBannerCentered from '../_blocks/CtaBannerCentered'
import TechnicalSupport from './_blocks/TechnicalSupport'
import ServiceComposition from './_blocks/ServiceComposition'
import Advantages from './_blocks/Advantages'
import WorkProcess from './_blocks/WorkProcess'
import ForWhom from './_blocks/ForWhom'
import Tariffs from './_blocks/Tariffs'
import Clients from '../_blocks/Clients'
import Portfolio from '@/app/portfolio/[portfolio]/_blocks/Portfolio'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

export default function SupportPage() {
	return (
		<>
			<Breadcrumbs className={styles.breadcrumbs} />
			<main className={styles.main}>
				<TechnicalSupport />
                <ServiceComposition />
                <Advantages 
					title="Решаем задачи бизнеса"
					description="Помогаем российским и зарубежным компаниям с помощью заказной разработки решать задачи бизнеса с учётом отраслевой специфики"
					stages={[
						{
							number: '01',
							title: 'Снижение рисков финансовых потерь',
							description: 'Предупреждение сбоев, ошибок, уязвимостей. Мониторинг активности и реагирование на атаки или угрозы безопасности'
						},
						{
							number: '02',
							title: 'Поддержка<br> ИТ-специалистов',
							description: 'Помощь в решении проблем, консультации по сопровождению сайта, проведение обучения специалистов по работе в системе.'
						},
						{
							number: '03',
							title: 'Улучшение метрик сайта и конверсии',
							description: 'Улучшение производительности сайта, пользовательского опыта, оптимизация контента и процесса совершения целевых действий'
						}
					]}
				/>
                <AnimatedSection animation="slideUp">
				<div className={styles.ctaBannerBlock}>
					<CtaBannerCentered />
				</div>
				</AnimatedSection>
                <WorkProcess />
                <ForWhom />
                <Tariffs />
                <AnimatedSection animation="slideUp">
				<div className={styles.portfolioBlock}>
					<Portfolio />
				</div>
                </AnimatedSection>
                <AnimatedSection animation="slideUp">
				<div className={styles.clientsBlock}>
					<Clients />
				</div>
                </AnimatedSection>
				<AnimatedSection animation="slideUp">
					<div className={styles.contactBlock}>
						<Contact />
					</div>
				</AnimatedSection>
			</main>
		</>
	)
}

